import {useRef, useState} from "react";

import {DataTable} from "primereact/datatable";
import {InputText} from "primereact/inputtext";
import {Column} from "primereact/column";
import {InputNumber} from 'primereact/inputnumber';
import {Dropdown} from 'primereact/dropdown';
import {Tag} from 'primereact/tag';
import {Button} from "primereact/button";
import 'primeicons/primeicons.css';
import {Calendar} from 'primereact/calendar';
import 'primereact/resources/themes/md-light-deeppurple/theme.css'; // Or your chosen theme
import 'primereact/resources/primereact.min.css';
import dayjs from "dayjs";
import {ToJsDate, ToMySqlDate} from "../../utilities/ToMySqlDate";
import {generateRandomString} from "../../utilities/randomGenerator";
import {InputSwitch} from "primereact/inputswitch";

import {Checkbox} from 'primereact/checkbox';
import {FilterMatchMode} from "primereact/api";




export default function WorkerGrid({
                                    data,
                                    setData,
                                    workerDepartment,
                                    setAction,
                                }) {
  const titleOptions = ["Mr.", "Mrs.", "Ms."];
    const onCellEditComplete = (e) => {
        let _products = [...data];
        let {newData, field, newValue} = e;

        // Update the specific field in the row
        _products = _products.map(item => {
            if (item.id === e.rowData.id) {
                item[field] = newValue;
            }
            return item;
        })
        if (e.value !== newValue && e.rowData.firstName !== "" && e.rowData.department !== "") {
            setAction({mode: "Save", _data: e.rowData});
            setData(_products);
        }
    };
    const deleteTemplate = (rowData, options) => {
        const icon = 'pi pi-trash'
        const deleteRow = (rowData) => {
            let _data = data.filter(item => item.id !== rowData.id);
            if (_data.length > 0) {
                setAction({mode: "Delete", _data: rowData});
                setData(_data);
            } else {
                setAction({mode: "Delete", _data: rowData});
                const newData =
                    {
                        id: generateRandomString(4),
                        firstName: "",
                        lastName: "",
                        title: "Mr.",
                        nic: "",
                        department: "",
                        basicSalary: 0.0,
                        address: "",
                        fixedSalary: true,
                        mobilePhone: "",
                        employed: true,
                        hiredDate: dayjs(new Date()).format('YYYY-MM-DD'),
                        startTime:  "09:00:00",
                    }
                setData([newData]);

            }
        };
        return <Button type="button" icon={icon} className="p-button-sm p-button-text"
                       disabled={rowData.employed}
                       onClick={() => deleteRow(rowData)}/>;
    };
    const dropEditor = (options) => {
        return (
            <Dropdown
                value={options.value}
                options={workerDepartment}
                onChange={(e) => {
                    options.editorCallback(e.value)
                }}
                disabled={options.rowData.firstName === "" || options.rowData.nic === "" }
                className={"flex h-2rem align-items-center"}
            />
        );
    }
    const titleDropdown = (options) => {
        return (
            <Dropdown
                value={options.value}
                options={titleOptions}
                onChange={(e) => {
                    options.editorCallback(e.value)
                }}
                disabled={options.rowData.firstName === "" || options.rowData.lastName === "" || options.rowData.department === "" }
                className={"flex h-2rem align-items-center"}
            />
        );
    }

    const addTemplate = (rowData) => {
        const icon = 'pi pi-plus'
        const addNewLine = () => {
            const newData =                    {
                id: generateRandomString(4),
                firstName: "",
                lastName: "",
                title: "Mr.",
                nic: "",
                department: "Packing",
                basicSalary: 0.0,
                address: "",
                fixedSalary: true,
                mobilePhone: "",
                employed: true,
                hiredDate: dayjs(new Date()).format('YYYY-MM-DD'),
                startTime:  "09:00:00"
            }
            setData(prevData => [newData,...prevData ]);
        }
        return <Button type="button" icon={icon} className="p-button-sm p-button-text"
                       disabled={rowData.name === "" || (rowData.credit === 0 && rowData.debit === 0)}
                       onClick={() => addNewLine()}/>;
    }


    const booleanBody = (rowData, options) => {

        return <Checkbox onChange={e => {
            let _data = [...data];
            let __data
            _data = _data.map(item => {
                if (item.id === rowData.id) {
                    item[options.field] = e.checked;


                    __data = item;
                }
                return item;
            })
            setAction({mode: "Save", _data: __data});
            setData(_data);

        }} checked={rowData[options.field]}></Checkbox>


    }
    const numberEditor = (options, currentIndex) => {
            return <InputNumber inputStyle={{fontSize: '8px'}} value={options.value}

                            onChange={(e) => {
                                options.editorCallback(e.value)
                            }}
                                className={"flex h-2rem align-items-center"}
        ></InputNumber>;
    }
    const textEditor = (options) => {
        return <InputText style={{fontSize: '8px'}} type="text" value={options.value}
                          onChange={(e) => {
                              options.editorCallback(e.target.value)
                          }}
                          className={"flex h-2rem align-items-center"}

        />;
    };
   const dateBody = (rowData, column) => {
       const dt = dayjs(rowData[column.field])
           return <Tag style={{fontSize: '8px'}} value={ToJsDate(dt).format('DD-MM-YYYY')}></Tag>;
   }
   const dateEditor = (options) => {
       const handleDateChange = (e) => {
           const dt = e.value.toLocaleDateString('en-GB').split('/').reverse().join('-');
           options.editorCallback(dt)
       }
       return (
           <Calendar style={{fontSize: '8px'}} id="buttondisplay" dateFormat="dd/mm/yy"             className={"flex h-2rem align-items-center"}
                     value={options.value} onChange={(e) => handleDateChange(e)} selectionMode={"single"}/>
       );
   }
    const timeBody = (rowData, column) => {
        const time = rowData[column.field]
        return <Tag style={{fontSize: '8px'}} value={time}></Tag>;
    }
    const timeEditor = (options) => {
        const handleTimeChange = (e) => {
                const dt = e.value.toLocaleTimeString('en-GB');
            options.editorCallback(dt)
        }
        return (
            <Calendar value={options.value} onChange={ handleTimeChange} timeOnly  selectionMode={"single"}
                      className={"flex h-2rem align-items-center"}/>
          
        );
    }
    const idTemplate = (rowData, column) => {
       return <Tag style={{fontSize: '8px'}} value={Number.isInteger(rowData.id)? rowData.id: "-"}/>;
    }
    return (
        <div className="card container-fluid w-full">
            <DataTable value={data} resizableColumns className="p-datatable-striped p-datatable-gridlines"
                       size={"small"} style={{fontSize: '9px'}}
                       filterDisplay="row"
                       editMode="cell"
                       sortField="date" sortOrder={-1}
                 //      virtualScrollerOptions={{ lazy: true, itemSize: 43, delay: 200, showLoader: true, }}
                       tableStyle={{minWidth: '50rem'}} stripedRows showGridlines={true} scrollable
                       scrollHeight="100vh">
                <Column field="+" header="Add" body={addTemplate}></Column>
                <Column field="id" header="ID" body={idTemplate} sortable></Column>
                <Column field="employed" header="Empoyed" sortable body={ booleanBody }></Column>
                <Column field="title" header="Title" editor={titleDropdown} onCellEditComplete={onCellEditComplete}/>
                <Column field="firstName" header="First Name" sortable editor={textEditor} onCellEditComplete={onCellEditComplete}/>
                <Column field="lastName" header="Last Name" sortable editor={textEditor} onCellEditComplete={onCellEditComplete}/>
                <Column field="department" header="Group" editor={dropEditor} onCellEditComplete={onCellEditComplete}/>
                <Column field="nic" header="NIC" editor={textEditor} onCellEditComplete={onCellEditComplete}/>
                <Column field="address" header="Address" editor={textEditor} onCellEditComplete={onCellEditComplete}></Column>
                <Column field="mobilePhone" header="Mobile" editor={textEditor} onCellEditComplete={onCellEditComplete}/>
                <Column field="fixedSalary" header="Fixed Salary" sortable body={ booleanBody }  />
                <Column field="basicSalary" header="Basic" sortable editor={numberEditor} onCellEditComplete={onCellEditComplete} />
                <Column field="hiredDate" header="Date Hired" editor={dateEditor}  body={dateBody} onCellEditComplete={onCellEditComplete}/>
                <Column field="startTime" header="Start Time" editor={timeEditor}  body={ timeBody } onCellEditComplete={onCellEditComplete}/>
                <Column field="remove" header="Remove" body={deleteTemplate}></Column>

            </DataTable>
        </div>
    );
}
;